const escapeCsvValue = (value: unknown): string => {
  const stringValue = value === null || value === undefined ? "" : String(value);
  if (/[",\n]/.test(stringValue)) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

export const rowsToCsv = (rows: unknown[][]): string =>
  rows.map((row) => row.map(escapeCsvValue).join(",")).join("\r\n");

export interface CsvSection {
  title?: string;
  headers: unknown[];
  rows: unknown[][];
}

export const buildCsvFromSections = (sections: CsvSection[]): string => {
  const blocks = sections.map((section) => {
    const lines: unknown[][] = [];
    if (section.title) lines.push([section.title]);
    lines.push(section.headers);
    lines.push(...section.rows);
    return rowsToCsv(lines);
  });
  return blocks.join("\r\n\r\n");
};

export const downloadCsv = (filename: string, csvContent: string): void => {
  const blob = new Blob([`﻿${csvContent}`], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
